export default __webpack_public_path__ + "static/media/Armbands of Necrotic Dread.e0bb7ebf.jpg";